import { Link } from "react-router";
import type { ReactNode } from "react";
import type { ButtonVariant } from "./Button";
import styles from "./Button.module.css";

type LinkButtonProps = {
  href: string;
  variant: ButtonVariant;
  children: ReactNode;
  // Row-level toggles (open an editor, close it again) are one state, not a
  // trail of history entries the back button has to walk out of.
  shouldReplaceHistory?: boolean;
};

// Shares Button's stylesheet so a link-shaped action and a real button cannot
// drift apart visually.
export const LinkButton = ({
  href,
  variant,
  children,
  shouldReplaceHistory,
}: LinkButtonProps) => (
  <Link
    to={href}
    replace={shouldReplaceHistory}
    className={styles.button}
    data-variant={variant}
  >
    {children}
  </Link>
);
